import { useCallback, useEffect, useState } from 'react';
import { utenze } from '../../api/utenze';
import type { IndirizzoBloccato } from '../../api/utenze';
import { formattaDataOra } from '../../lib/formato';

/*  GLI INDIRIZZI BLOCCATI, SOPRA L'ELENCO DELLE UTENZE. 23/10/2026: dopo cinque
    tentativi d'accesso sbagliati in un minuto, un indirizzo IP pubblico resta bloccato
    finche' qualcuno non lo sblocca da qui. Chi lo sblocca riceve anche l'avviso sotto la
    campanella. Quando non ce ne sono, non si vede niente.  */
export function IndirizziBloccati() {
  const [elenco, setElenco] = useState<IndirizzoBloccato[]>([]);
  const [inCorso, setInCorso] = useState<string | null>(null);
  const [errore, setErrore] = useState<string | null>(null);

  const leggi = useCallback(() => {
    utenze
      .bloccati()
      .then(setElenco)
      .catch((e: Error) => setErrore(e.message));
  }, []);

  useEffect(leggi, [leggi]);

  async function sblocca(b: IndirizzoBloccato) {
    setInCorso(b.id);
    setErrore(null);
    try {
      await utenze.sblocca(b.id);
      leggi();
    } catch (e) {
      setErrore((e as Error).message);
    } finally {
      setInCorso(null);
    }
  }

  if (elenco.length === 0 && !errore) return null;

  return (
    <section className="riquadro indirizzi-bloccati" aria-label="Indirizzi bloccati">
      <h2>Indirizzi bloccati</h2>
      <p className="nota">
        Bloccati dopo cinque tentativi d’accesso sbagliati in un minuto. Prima di sbloccare,
        vale la pena sapere di chi è l’indirizzo: un tecnico che ha sbagliato la password dal
        cellulare, o qualcuno che sta provando.
      </p>
      {errore && <p className="errore">{errore}</p>}
      <table>
        <thead>
          <tr>
            <th>Indirizzo</th>
            <th>Bloccato il</th>
            <th>Tentativi</th>
            <th>Ultima rotta</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {elenco.map((b) => (
            <tr key={b.id}>
              <td>{b.indirizzo}</td>
              <td>{formattaDataOra(b.bloccatoIl)}</td>
              <td>{b.tentativi}</td>
              <td>{b.ultimaRotta ?? ''}</td>
              <td>
                <button type="button" disabled={inCorso !== null} onClick={() => void sblocca(b)}>
                  Sblocca
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}
